import React from 'react';

const AdminRelatorios: React.FC = () => {
    return (
        <div className="flex flex-col gap-6">
            <div className="flex flex-wrap justify-between gap-3 items-center">
                <div className="flex min-w-72 flex-col gap-1">
                    <p className="text-[#374151] dark:text-[#E5E7EB] text-3xl font-bold leading-tight tracking-tight">Relatórios</p>
                    <p className="text-[#6B7280] dark:text-[#9CA3AF] text-base font-normal leading-normal">Visualize relatórios detalhados.</p>
                </div>
            </div>
            <div className="bg-white dark:bg-[#111827] border border-[#E5E7EB] dark:border-[#374151] rounded-xl p-6">
                <p className="text-[#6B7280] dark:text-[#9CA3AF]">Conteúdo da página de relatórios...</p>
            </div>
        </div>
    );
};

export default AdminRelatorios;
